import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthenticateService } from 'src/app/core/services/authenticate.service';
import { FormsService } from 'src/app/core/services/forms.service';

@Component({
  selector: 'app-send-form-dialog',
  templateUrl: './send-form-dialog.component.html',
  styleUrls: ['./send-form-dialog.component.scss']
})
export class SendFormDialogComponent implements OnInit {

  customerID:number;
  customerEmail: string;
  customerHasEmail=false;

  constructor(private router: Router,
    private authService: AuthenticateService,
    public dialogRef: MatDialogRef<SendFormDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formService: FormsService) { }

  ngOnInit(): void {
       this.customerHasEmail =  !!this.data.patient.Email;
  }

  onSendToCustomer(){   
    // this.router.navigate(['/login']); 
    this.data.result = FormsService.SEND_TO_CUSTOMER; 
    this.data.therapistID = null; 
    this.dialogRef.close(this.data);
  }

  onFillByTherapist(){
    
    this.data.result = FormsService.FILL_BY_THERAPIST; 
    this.data.therapistID = this.authService.currentUser.id;
    this.dialogRef.close(this.data);
  }

  onCancel(){
    this.data.result = 'caneled'; 
    this.dialogRef.close(this.data);
  }

}
